export default __webpack_public_path__ + "2b1acd31272319f20c2864e94718e032.png";